module.exports = __webpack_public_path__ + "img/top.a196b69e.svg";